var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BC1535;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,20c0,11.05-8.95,20-20,20h0C8.95,40,0,31.05,0,20v0C0,8.95,8.95,0,20,0h0C31.05,0,40,8.95,40,20L40,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.93,18.45l-0.33,2.68c-0.06,0.45-0.43,0.78-0.88,0.78h-4.33v11.19c-0.46,0.04-0.92,0.06-1.39,0.06 c-1.05,0-2.07-0.1-3.06-0.3V21.91H12.6c-0.31,0-0.56-0.25-0.56-0.56V18c0-0.31,0.25-0.56,0.56-0.56h3.33v-5.02 c0-3.08,2.49-5.58,5.56-5.58h3.89c0.31,0,0.56,0.25,0.56,0.56v3.35c0,0.31-0.25,0.56-0.56,0.56H22.6c-1.23,0-2.22,1-2.22,2.23v3.91 h4.67C25.58,17.44,25.99,17.92,25.93,18.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.0222f859f1ce91cd5e9b0476f7ece6fa.svg";
export { ForwardRef as ReactComponent };